<template>
    <div class="row federations__map-row">
        <div class="col-lg-5 col-sm-12 maprow-info">

            <h2 class="title">{{ this.fedname }}</h2>
            <span class="text-secondary fw-500">Nessun costo, nessun vincolo</span>
            <div class="subtitle">1. Scrivi il codice fiscale della società e trova la tua pagina
            </div>
            <div>
                <input type="text" v-model="codFiscale" placeholder="Inserisci il Codice fiscale" class="shadow-sm form-control">
            </div>
            <div class="text-center mt-2">
                <button type="button" class="btn btn-primary w-100 " @click="searchCompany">Trova la tua pagina</button>
            </div>
            <div class="subtitle">2. Gestisci la tua pagina e pubblica i tuoi corsi
            </div>
            <div v-if="searchError==false">
                <p>Risultati ricerca:</p>
                <div class="mt-3 p-3 border rounded row d-flex no-gutters w-lg-75">
                    <div class="col-1"><img src="/images/federation/marker.png"></div>
                    <div class="col-11">
                        <div class="title-search">{{ this.boxSearchContainer.name }}</div>
                        <div class="address-search">{{ this.boxSearchContainer.address }}</div>
                        <div class="sports-seaarch mt-2">{{ this.boxSearchContainerSports.join() }}</div>
                    </div>
                    <div class="col-12">
                        <a v-if="infoContent.info.hidden == 0" href="/login"
                           class="btn btn-primary w-100">Accedi</a>
                        <a v-else class="btn btn-primary w-100" target="_blank" :href="
                            fedUrl +
                        '?nome_societa=' + infoContent.info.name +
                        '&autocomplete=' + infoContent.info.address +
                        '&codice_fiscale=' + infoContent.info.codFiscale +
                        '&street_number=' + infoContent.info.street_number +
                        '&postal_code=' + infoContent.info.postal_code +
                        '&country=' + infoContent.info.country +
                        '&longitude=' + infoContent.info.longitude +
                        '&latitude=' + infoContent.info.latitude +
                        '&route=' + infoContent.info.route +
                        '&locality=' + infoContent.info.locality +
                        '&administrative_area_level_1=' + infoContent.info.administrative_area_level_1">Gestisci la tua pagina</a>
                    </div>
                </div>
            </div>
            <div v-if="searchError==true">Nessun risultato trovato</div>
        </div>
        <div class="col-lg-7 col-sm-12 maprow-map mb-2 mt-5 mt-sm-1">
            <span class="d-none d-md-block text-uppercase text-center fw-600 mb-2">Siamo già in tantissimi su Orangogo</span>
            <google-map ref="gmapref" :center="center"
                        :options="mapOptions"
                        :style="mapStyle"
            >
                <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen"
                                  @closeclick="infoWinOpen=false">
                    <div v-if="infoContent.info" class="d-flex federations__map-row__info-window">
                        <div class="col-4 p-0 d-none d-lg-block">
                            <b-img class="left-image"
                                   :src="(infoContent.info.hidden == 0) ? infoContent.info.logo : fedlogo"
                                   alt=""></b-img>
                        </div>
                        <div class="col-8 p-3">
                            <div class="mb-2"><a :href="infoContent.info.url"
                                                 class="info-url">{{infoContent.info.name}}</a></div>
                            <div class="mb-2 info-text">{{ infoContent.info.address }}</div>
                            <div v-if="infoContent.info.sports" class="mb-2 info-text text-uppercase">
                                {{infoContent.info.sports.join() }}
                            </div>
                            <div class="d-flex mt-2" v-if="infoContent.info.hidden == 0">
                                <div class="col-8 text-left"></div>
                                <div class="col-4 text-right"><a href="/login"
                                                                 class="btn btn-transparent font-bold text-primary">Accedi</a>
                                </div>
                            </div>
                            <div v-else class="d-flex mt-2"><a class="btn btn-primary" target="_blank" :href="
                            fedUrl +
                        '?nome_societa=' + infoContent.info.name +
                        '&autocomplete=' + infoContent.info.address +
                        '&codice_fiscale=' + infoContent.info.codFiscale +
                        '&street_number=' + infoContent.info.street_number +
                        '&postal_code=' + infoContent.info.postal_code +
                        '&country=' + infoContent.info.country +
                        '&longitude=' + infoContent.info.longitude +
                        '&latitude=' + infoContent.info.latitude +
                        '&route=' + infoContent.info.route +
                        '&locality=' + infoContent.info.locality +
                        '&administrative_area_level_1=' + infoContent.info.administrative_area_level_1">Gestisci la tua pagina</a></div>
                        </div>

                    </div>
                </gmap-info-window>
                <google-map-cluster :styles="clusterStyle" :minimum-cluster-size="5" :zoom-on-click="true">
                    <google-map-marker
                            :key="result.info.id"
                            :ref="'marker-' + result.info.id"
                            v-for="result in markers"
                            :position="result.position"
                            :clickable="true"
                            icon="/images/map/map_marker.svg"
                            @click="toggleInfoWindow(result,result.info.id, true)"
                    >
                    </google-map-marker>
                </google-map-cluster>
            </google-map>
        </div>
    </div>
</template>
<style>
    .gm-style .gm-style-iw-c {
        padding: 0px !important;
        width: 466px !important;

    }

    .gm-style-iw-d {
        overflow: inherit !important;
    }
</style>

<script>
    import {gmapApi} from 'vue2-google-maps'
    import GoogleMapCluster from 'vue2-google-maps/dist/components/cluster'

    export default {
        name: 'FedMapContainer',
        components: {
            GoogleMapCluster
        },
        props: ['fedProp', 'fednameProp', 'fedlogoProp', 'fedurlProp'],
        created() {
            this.fed = this.fedProp
            this.fedname = this.fednameProp
            this.fedlogo = this.fedlogoProp
            this.fedUrl = this.fedurlProp
            console.log(this.fedUrl)
        },
        mounted() {
            this.getCompanies();
        },
        data() {
            return {
                fed: null,
                fedname: null,
                fedlogo: null,
                fedUrl: null,
                center: {
                    lat: 42.0383047,
                    lng: 12.0026591
                },
                map: null,
                infoWindow: null,
                clusterStyle: [
                    {
                        url: '/images/map/map_cluster.svg',
                        textColor: '#424242',
                        width: 35,
                        height: 49,
                        anchorText: [-6, 0],
                        anchorIcon: [45, 8],
                        textSize: 12
                    },
                    {
                        url: '/images/map/map_cluster.svg',
                        textColor: '#424242',
                        width: 35,
                        height: 49,
                        anchorText: [-6, 0],
                        anchorIcon: [45, 8],
                        textSize: 12
                    },
                    {
                        url: '/images/map/map_cluster.svg',
                        textColor: '#424242',
                        width: 35,
                        height: 49,
                        anchorText: [-6, 0],
                        anchorIcon: [45, 8],
                        textSize: 12
                    }
                ],
                mapOptions: {
                    zoom: 5,
                    disableDefaultUI: true,
                    zoomControl: true,
                    fullscreenControl: true,
                    styles: [
                        {
                            "width": "100%",
                            "height": "500px"
                        },
                        {
                            "featureType": "landscape",
                            "stylers": [
                                {
                                    "hue": "#FFBB00"
                                },
                                {
                                    "saturation": 43.400000000000006
                                },
                                {
                                    "lightness": 37.599999999999994
                                },
                                {
                                    "gamma": 1
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "stylers": [
                                {
                                    "hue": "#FFC200"
                                },
                                {
                                    "saturation": -61.8
                                },
                                {
                                    "lightness": 45.599999999999994
                                },
                                {
                                    "gamma": 1
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "stylers": [
                                {
                                    "hue": "#FF0300"
                                },
                                {
                                    "saturation": -100
                                },
                                {
                                    "lightness": 51.19999999999999
                                },
                                {
                                    "gamma": 1
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "stylers": [
                                {
                                    "hue": "#FF0300"
                                },
                                {
                                    "saturation": -100
                                },
                                {
                                    "lightness": 52
                                },
                                {
                                    "gamma": 1
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "stylers": [
                                {
                                    "hue": "#0078FF"
                                },
                                {
                                    "saturation": -13.200000000000003
                                },
                                {
                                    "lightness": 2.4000000000000057
                                },
                                {
                                    "gamma": 1
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "stylers": [
                                {
                                    "hue": "#00FF6A"
                                },
                                {
                                    "saturation": -1.0989010989011234
                                },
                                {
                                    "lightness": 11.200000000000017
                                },
                                {
                                    "gamma": 1
                                }
                            ]
                        }],
                },
                mapStyle: [
                    {
                        "width": "100%",
                        "height": "500px"
                    },
                ],
                markers: [],
                codFiscale: null,
                searchError: null,
                boxSearchContainer: [],
                boxSearchContainerSports: [],
                infoContent: [],
                infoWindowPos: null,
                infoWinOpen: false,
                currentMidx: null,
                //optional: offset infowindow so it visually sits nicely on top of our marker
                infoOptions: {
                    pixelOffset: {
                        width: 0,
                        height: -35
                    }
                },
            }

        },
        computed: {
            google: gmapApi,
        },
        methods: {
            getCompanies: function () {

                var self = this;

                axios({
                    method: 'post',
                    url: 'get-fed-companies',
                    data: {
                        fed: this.fed
                    }
                }).then((response) => {

                    response.data.companies.forEach(element => {
                        this.markers.push(self.getPosition(element));
                    });
                }).catch((error) => {
                    console.log('error')
                });
            },
            getPosition(result, sports = null) {
                if (result.isArray)
                    return {
                        position: {lat: result['latitude'] * 1, lng: result['longitude'] * 1},
                        info: {
                            id: result['id'],
                            name: result['name'],
                            url: result['url'],
                            logo: result['logo_path'],
                            address: result['address'],
                            hidden: result['hidden_page'],
                            sports: [],
                            codFiscale: result['fiscal_code'],
                            email: result['email'],
                            street_number: result['house_number'],
                            postal_code: result['postal_code'],
                            route: result['route'],
                            locality: result['municipality'],
                            country: result['country'],
                            latitude: result['latitude'],
                            longitude: result['longitude'],
                            administrative_area_level_1: result['province']


                        }
                    }
                else
                    return {
                        position: {lat: result.latitude * 1, lng: result.longitude * 1},
                        info: {
                            id: result.id,
                            name: result.name,
                            url: result.url,
                            logo: result.logo_path,
                            address: result.address,
                            hidden: result.hidden_page,
                            sports: sports,
                            codFiscale: result.fiscal_code,
                            email: result.email,
                            street_number: result.house_number,
                            postal_code: result.postal_code,
                            route: result.route,
                            locality: result.municipality,
                            country: result.country,
                            latitude: result.latitude,
                            longitude: result.longitude,
                            administrative_area_level_1: result.province
                        }
                    }
            },
            searchCompany: function () {
                var self = this;
                this.searchError = null
                axios({
                    method: 'post',
                    url: 'get-fed-company',
                    data: {
                        cod: this.codFiscale,
                        fed: this.fed
                    }
                }).then((response) => {
                    if (!response.data.company)
                        this.searchError = true
                    else {
                        this.boxSearchContainer = response.data.company
                        this.boxSearchContainerSports = response.data.sports
                        this.searchError = false

                        const pos = self.getPosition(this.boxSearchContainer)
                        self.toggleInfoWindow(pos, this.boxSearchContainer.id)
                    }
                }).catch((error) => {
                    console.log('error')
                    this.searchError = false
                });
            },
            toggleInfoWindow: function (marker, idx, fromMap = false) {
                this.infoWindowPos = marker.position;
                this.infoContent = marker;
                this.$refs.gmapref.$mapObject.setZoom(9)
                this.$refs.gmapref.$mapObject.setCenter(marker.position)

                var self = this;

                if (this.currentMidx == idx) {
                    this.infoWinOpen = !this.infoWinOpen;
                }

                else {
                    this.infoWinOpen = true;
                    this.currentMidx = idx;
                }
                console.log(self.infoContent.info);
                if (fromMap === true)
                    axios({
                        method: 'post',
                        url: 'get-fed-company-by-id',
                        data: {
                            id: this.currentMidx,
                            fed: this.fed
                        }
                    }).then((response) => {
                        if (response.data.sports) {
                            self.infoContent.info.sports = response.data.sports
                        }
                    }).catch((error) => {
                        console.log('error')
                    });

            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/federation/FedMapContainer.vue